import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t,
    language
  } = useLanguage();
  return <footer className="bg-carbon border-t border-white/5 py-16 px-6 z-10 relative" data-id="element-59">
      <div className="max-w-[1800px] mx-auto grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-60">
        <div className="col-span-1 md:col-span-2" data-id="element-61">
          <Link to="/" className="block mb-6" data-id="element-62">
            <h3 className="font-display text-2xl font-bold tracking-tighter text-ivory" data-id="element-63">
              NEW ASIA TECH
            </h3>
          </Link>
          <p className="text-gray-400 text-sm mb-2 font-light" data-id="element-64">
            {language === 'en' ? 'Technology Beyond Control.' : 'Teknologi Melampaui Kendali.'}
          </p>
          <p className="text-graphite max-w-md mb-8 font-light leading-relaxed text-sm" data-id="element-65">
            {t('footer.desc')}
          </p>
          <div className="text-xs text-graphite font-mono space-y-1" data-id="element-66">
            <div data-id="element-67">
              {language === 'en' ? 'Part of the NETKRIDA Group' : 'Bagian dari Grup NETKRIDA'}
            </div>
            <a href="https://netkrida.co.id" target="_blank" rel="noopener noreferrer" className="text-muted-gold hover:text-ai-teal transition-colors inline-block" data-id="element-68">
              PT NETKRIDA TUAH CAKRAWALA →
            </a>
          </div>
        </div>

        <div data-id="element-69">
          <h4 className="text-xs font-mono text-muted-gold uppercase tracking-widest mb-6" data-id="element-70">
            {t('footer.institution')}
          </h4>
          <ul className="space-y-4" data-id="element-71">
            <li data-id="element-72">
              <Link to="/about" className="text-sm text-gray-400 hover:text-ai-teal transition-colors" data-id="element-73">
                {t('nav.about')}
              </Link>
            </li>
            <li data-id="element-74">
              <Link to="/philosophy" className="text-sm text-gray-400 hover:text-ai-teal transition-colors" data-id="element-75">
                {t('nav.philosophy')}
              </Link>
            </li>
            <li data-id="element-76">
              <Link to="/ethics" className="text-sm text-gray-400 hover:text-ai-teal transition-colors" data-id="element-77">
                {t('nav.ethics')}
              </Link>
            </li>
            <li data-id="element-78">
              <Link to="/contact" className="text-sm text-gray-400 hover:text-ai-teal transition-colors" data-id="element-79">
                {t('nav.contact')}
              </Link>
            </li>
          </ul>
        </div>

        <div data-id="element-80">
          <h4 className="text-xs font-mono text-muted-gold uppercase tracking-widest mb-6" data-id="element-81">
            {t('footer.domains')}
          </h4>
          <ul className="space-y-4" data-id="element-82">
            <li data-id="element-83">
              <Link to="/solutions" className="text-sm text-gray-400 hover:text-ai-teal transition-colors" data-id="element-84">
                {t('nav.solutions')}
              </Link>
            </li>
            <li data-id="element-85">
              <Link to="/technology" className="text-sm text-gray-400 hover:text-ai-teal transition-colors" data-id="element-86">
                {t('nav.technology')}
              </Link>
            </li>
            <li data-id="element-87">
              <a href="https://netkrida.co.id" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-ai-teal transition-colors" data-id="element-88">
                {t('nav.insights')}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1800px] mx-auto mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center text-xs text-graphite font-mono" data-id="element-89">
        <p data-id="element-90">
          &copy; {new Date().getFullYear()} NEW ASIA TECH.{' '}
          {language === 'en' ? 'All Rights Reserved.' : 'Hak Cipta Dilindungi.'}
        </p>
      </div>
    </footer>;
}